import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="submit-once"
// For forms with Turbo disabled (data: {turbo: false}), Turbo's own
// disable-on-submit behavior doesn't apply. Disables the submit button and
// swaps its label to the data-wait text to prevent double submission.
export default class extends Controller {
	static targets = ["button", "label"];

	submit(event) {
		if (this.disabledHere || this.buttonTarget.disabled) {
			event.preventDefault();
			return;
		}

		// A form with several submit buttons disables the one that was pressed.
		this.button = this.buttonTargets.includes(event.submitter) ? event.submitter : this.buttonTarget;

		this.originalLabel = this.readLabel();
		this.disabledHere = true;
		this.button.disabled = true;
		this.writeLabel(this.button.dataset.wait);
	}

	// Back from the Asaas invoice, or from our own /pix page. The browser restores
	// the frozen DOM from the bfcache, so the button comes back disabled and still
	// reading "Aguarde…", and only a reload frees it. Bound to pageshow@window.
	//
	// Only undoes what THIS controller did: the checkout submit ships disabled
	// when no carrier can be quoted, and shipping-totals disables it while a quote
	// is in flight — neither is ours to re-enable.
	reset(event) {
		if (!event.persisted || !this.disabledHere) return;

		this.disabledHere = false;
		this.button.disabled = false;
		this.writeLabel(this.originalLabel);
	}

	// Three shapes, most specific first. A button that also holds an icon
	// declares a label target, because writing textContent on the button
	// itself would delete the icon along with the old label (the checkout
	// submit). Otherwise: button_to (Rails 8 default) renders a <button>,
	// whose label is its content; form.submit renders an
	// <input type="submit">, whose label is its value.
	readLabel() {
		if (this.hasLabelTarget) return this.labelTarget.textContent;
		if (this.button.tagName === "BUTTON") return this.button.textContent;
		return this.button.value;
	}

	writeLabel(text) {
		if (text === undefined) return;

		if (this.hasLabelTarget) {
			this.labelTarget.textContent = text;
		} else if (this.button.tagName === "BUTTON") {
			this.button.textContent = text;
		} else {
			this.button.value = text;
		}
	}
}
